export const WindowsLogo = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="60px" height="60px">
      <path fill="#1976d2" d="M6,6h17v17H6V6z" />
      <path fill="#1976d2" d="M25.042,22.958V6H42v16.958H25.042z" />
      <path fill="#1976d2" d="M6,25h17v17H6V25z" />
      <path fill="#1976d2" d="M25,42V25h17v17H25z" />
    </svg>
  );